import { graphql } from 'src/graphql';

export const MessagesFields = graphql(`
  fragment MessagesFields on Messages @_unmask {
    _id
    type
    body
    seen
    created
    _to_user_id
    _from_user_id
    direction
  }
`);
